import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["striped", "selectable", "children"];
import React from 'react';
import TableRow from './TableRow';

var TableBody = function TableBody(_ref) {
  var striped = _ref.striped,
      selectable = _ref.selectable,
      children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var decoratedChildren = [striped, selectable].every(function (value) {
    return value == null;
  }) ? children : React.Children.toArray(children).map(function (child, index) {
    if ( /*#__PURE__*/React.isValidElement(child) && child.type === TableRow) {
      var extraProps = _objectSpread({
        striped: striped && index % 2 === 1,
        selectable: selectable
      }, child.props ? child.props : {});

      return /*#__PURE__*/React.cloneElement(child, extraProps);
    }

    return child;
  });
  return /*#__PURE__*/React.createElement("tbody", unhandledProps, decoratedChildren);
};

TableBody.displayName = 'TableBody';
export default TableBody;